const Desktop = 'Desktop';
const Tablet = 'Tablet';
const Mobile = 'Mobile';

export { Desktop, Tablet, Mobile };
export default { Desktop, Tablet, Mobile };
